import { getHubsApiClient } from 'lib/SplashApiClient/subclients/HubsApiClient';
import normalizeApiResponse from 'utils/normalizeApiResponse';
import { getGlobalHubName } from 'common/store/userProperties/selectors';
import get from 'lodash/get';
import { notifySuccess } from 'common/compounds/Notification/modules';
import Logger from 'observability/Logger';
import actionTypes from '../constants/actionTypes';
import { hubsSchema } from '../schemas';

const LOG = new Logger('AddToHubModal-actions');
const hubsApiClient = getHubsApiClient();
const {
    OPENED_ADD_TO_HUB_MODAL,
    CLOSED_ADD_TO_HUB_MODAL,
    SET_SELECTED_EVENTS,
    FETCH_HUBS_REQUEST,
    FETCH_HUBS_SUCCESS,
    FETCH_HUBS_ERROR,
    ADD_TO_HUBS_REQUEST,
    ADD_TO_HUBS_SUCCESS,
    ADD_TO_HUBS_ERROR,
    SELECT_HUB,
    UNSELECT_HUB,
    SET_SEARCH_TERM,
    SET_SORT_MODE,
    CLEAR_NOTIFICATION_MESSAGE,
} = actionTypes;

const HUB_NAME = 'hub';

const createSuccessMessage = (eventCount, hubCount, hubName) =>
    `${eventCount === 1 ? 'This event has' : `${eventCount} events have`} been successfully added to the selected ${
        hubCount === 1 ? hubName : `${hubCount} ${hubName}s`
    }`;

const createActionLoadHubs = (page) => ({ type: FETCH_HUBS_REQUEST, page });

const createActionFinishedLoadingHubs = (response) => ({
    type: FETCH_HUBS_SUCCESS,
    payload: normalizeApiResponse(response.data, hubsSchema),
    page: response.page,
    pages: Math.ceil(response.pagination.count / response.pagination.limit),
    count: response.count,
});

const createActionErrorLoadingHubs = () => ({
    type: FETCH_HUBS_ERROR,
});

export const openAddToHubModal = () => ({ type: OPENED_ADD_TO_HUB_MODAL });

export const closeAddToHubModal = () => ({ type: CLOSED_ADD_TO_HUB_MODAL });

export const setSelectedEvents = (eventIds) => ({
    type: SET_SELECTED_EVENTS,
    eventIds,
});

export const fetchHubs =
    (page = 1, options) =>
    (dispatch) => {
        dispatch(createActionLoadHubs(page));

        return hubsApiClient
            .fetchHubs({
                ...options,
                page,
            })
            .then((response) => {
                // Safety check to prevent events flagged as hubs, but without hub, to be included.
                const responseWithHubEvents = {
                    ...response,
                    data: (response.data || []).filter((event) => event.splash_hub != null),
                };
                dispatch(createActionFinishedLoadingHubs(responseWithHubEvents));

                return response;
            })
            .catch((error) => {
                LOG.error('Error on fetchHubs', error);
                dispatch(createActionErrorLoadingHubs());
            });
    };

export const addEventsToHubs = (eventIds, hubIds, featured) => (dispatch, getState) => {
    const eventCount = eventIds.length;
    const hubCount = hubIds.length;
    const hubName = getGlobalHubName(getState()) || HUB_NAME;

    dispatch({ type: ADD_TO_HUBS_REQUEST });

    return hubsApiClient
        .addEventsToHubs(eventIds, hubIds, featured)
        .then((results) => {
            dispatch({
                type: ADD_TO_HUBS_SUCCESS,
                message: createSuccessMessage(eventCount, hubCount, hubName),
            });

            dispatch(closeAddToHubModal());
        })
        .catch((results) => {
            dispatch({
                type: ADD_TO_HUBS_ERROR,
                message: get(results, 'data.meta.message', ''),
            });
        });
};

export const openNotification = (message) => (dispatch) => dispatch(notifySuccess(message));

export const selectHub = (hubId) => ({ type: SELECT_HUB, hubId });

export const unselectHub = (hubId) => ({ type: UNSELECT_HUB, hubId });

export const setSearchTerm = (searchTerm) => ({
    type: SET_SEARCH_TERM,
    searchTerm,
});

export const setSortMode = (sortMode) => ({ type: SET_SORT_MODE, sortMode });

export const clearNotificationMessage = () => ({
    type: CLEAR_NOTIFICATION_MESSAGE,
});
